module.exports = __webpack_public_path__ + "img/dashboard.31a69a9b.png";